import {FieldInterface} from "@/types/Field.interface";

export const FieldSchema: FieldInterface = {
    label: null,
    placeholder: null,
    value: null,
    error: null,
    isDisabled: null,
    isRequired: null,
    isLoading: null,
    variants: {},
}
